import { type FC, useMemo } from 'react';
import { noop } from 'lodash';
import classNames from 'classnames';
// Import UI Components
import Switch from 'react-switch';

interface Props {
    index: number;
    getTabKey: (tabKey: Nilable<string | number>, index: number) => string | number;
    tabClickHandler: (key: string | number) => () => void;
    activeKey: string | number;
    tabKey?: Nullable<string | number>;
    tabTitle: string | React.ReactNode;
    hasSwitcher?: boolean;
    switchChangeHandler?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    switcherChecked?: boolean;
    isValid?: boolean;
    isDisabled?: boolean;
}

const CustomTab: FC<Props> = (props) => {
    const {
        tabKey,
        tabTitle,
        hasSwitcher = false,
        switchChangeHandler = noop,
        switcherChecked = false,
        index,
        getTabKey,
        tabClickHandler,
        activeKey,
        isValid = true,
        isDisabled = false,
    } = props;
    const customTab = useMemo(
        () =>
            hasSwitcher ? (
                <li
                    key={getTabKey(tabKey, index)}
                    className={classNames('crm-custom-tabs-tab-with-switcher', {
                        active: getTabKey(tabKey, index) === activeKey,
                        'active-switcher': switcherChecked,
                    })}
                >
                    <button className={'crm-custom-tabs-tab'} onClick={tabClickHandler(getTabKey(tabKey, index))}>
                        <span className="test">{tabTitle}</span>
                    </button>
                    <Switch
                        onChange={switchChangeHandler}
                        checked={switcherChecked}
                        width={36}
                        height={18}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        className="crm-custom-tab-switcher"
                    />
                </li>
            ) : (
                <li
                    key={getTabKey(tabKey, index)}
                    className={classNames({ active: getTabKey(tabKey, index) === activeKey, invalid: !isValid })}
                >
                    <button onClick={tabClickHandler(getTabKey(tabKey, index))} disabled={isDisabled}>
                        {tabTitle}
                    </button>
                </li>
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [activeKey, switcherChecked, tabTitle, isValid],
    );
    return customTab;
};

export default CustomTab;
